var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeleteRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_9093",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_9093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0898 23.0831C11.6742 23.0831 11.3192 22.936 11.0248 22.6417C10.7305 22.3472 10.5833 21.9922 10.5833 21.5767V10.9998H9.75V9.74978H13.5V9.0127H18.5V9.74978H22.25V10.9998H21.4167V21.5767C21.4167 21.9976 21.2708 22.3539 20.9792 22.6456C20.6875 22.9373 20.3312 23.0831 19.9102 23.0831H12.0898ZM20.1667 10.9998H11.8333V21.5767C11.8333 21.6515 11.8574 21.713 11.9054 21.761C11.9535 21.8091 12.0149 21.8331 12.0898 21.8331H19.9102C19.9744 21.8331 20.0331 21.8064 20.0865 21.7529C20.1399 21.6996 20.1667 21.6408 20.1667 21.5767V10.9998ZM13.8367 20.1664H15.0865V12.6664H13.8367V20.1664ZM16.9135 20.1664H18.1633V12.6664H16.9135V20.1664Z",
    fill: "#D00416"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteRecord);
export default __webpack_public_path__ + "static/media/ic_delete_record.85be9eb33fc483195443304fb34f51e5.svg";
export { ForwardRef as ReactComponent };